import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import toast from 'react-hot-toast';
import SwitchInput from '../../../shared/SwitchInput';

import CustomTable from '../../../shared/CustomTable';
import CustomPagination from '../../../shared/CustomPagination';
import { priceListSubTypesTableColumns } from '../../../constants/PriceListConstants';
import { DeleteIcon, EditIcon } from '../../../utils/TableActionIcons';
import CheckPermission from '../../../hooks/CheckPermission';
import { useTranslation } from 'react-i18next';
import {
  useUpdatePriceListSubTypeMutation,
  useDeletePriceListSubTypeMutation
} from '../../../redux/api/modules/managementApi';
const ConfirmationModal = React.lazy(() => import('../../../shared/ConfirmationModal'));

const PriceItemsSubTypeTable = ({
  loading,
  refetch,
  itemsData,
  payloadData,
  setPayloadData,
  selectedItemData,
  setSelectedItemData,
  setOpenCreatePriceTypeModal
}) => {
  const { hasPermission } = CheckPermission();
  const [updatePriceListSubType] = useUpdatePriceListSubTypeMutation();
  const [deletePriceListSubType] = useDeletePriceListSubTypeMutation();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const { t } = useTranslation();

  const handleToggleActive = async (rowData, value) => {
    const payload = {
      id: rowData?.id,
      name_en: rowData?.name_en,
      name_ar: rowData?.name_ar,
      price_list_type_id: rowData?.price_list_type_id,
      price_list_type: rowData?.price_list_type,
      is_active: value
    };
    try {
      const res = await updatePriceListSubType(payload).unwrap();
      if (res) {
        toast.success(res?.message || 'Updated successfully');
        if (typeof refetch === 'function') refetch('POST', '/v3/pricelist_subtypes/list', payloadData);
      }
    } catch (err) {
      toast.error(err?.data?.message || err?.message || 'Failed to update');
    }
  };

  const actionsCoumn = {
    body: actionsTemplate,
    header: t('Actions')
  };
  const columnsData = [actionsCoumn, ...priceListSubTypesTableColumns(t)]?.map(col => {
    if (col.field === 'is_active') {
      return {
        ...col,
        body: rowData => (
          <SwitchInput
           // disabled={!rowData?.price_list_type_id}
            value={rowData?.is_active}
            handleChange={(e) => handleToggleActive(rowData, e?.value)}
          />
        )
      };
    }
    return col;
  });

  function actionsTemplate(rowData) {
    return (
      <div className='flex items-center gap-1'>
        {hasPermission('pricelist_subtypes', 'update') && (
          <EditIcon
            onClick={() => {
              setOpenCreatePriceTypeModal(true);
              setSelectedItemData(rowData);
            }}
          />
        )}
        {/* {hasPermission('pricelist_subtypes', 'delete') && (
          <DeleteIcon
            onClick={() => {
              setSelectedItemData(rowData);
              setOpenConfirmationModal(true);
            }}
          />
        )} */}
      </div>
    );
  }

  const onPageChange = async (newPage, newRowsPerPage) => {
    const payload = {
      ...payloadData,
      page: newPage,
      per_page: newRowsPerPage
    };
    if (typeof refetch === 'function') refetch('POST', '/v3/pricelist_subtypes/list', payload);
    setPayloadData(payload);
  };

  const handleDeleteItem = async () => {
    if (selectedItemData) {
      setButtonLoading(true);
      try {
        const res = await deletePriceListSubType({ id: selectedItemData?.id }).unwrap();
        if (res) {
          toast.success(res?.message || 'Deleted successfully');
          if (typeof refetch === 'function') refetch('POST', '/v3/pricelist_types/list', payloadData);
          setOpenConfirmationModal(false);
          setSelectedItemData(null);
        }
      } catch (err) {
        toast.error(err?.data?.message || err?.message || 'Failed to delete');
      }
      setButtonLoading(false);
    }
  };

  return (
    <div className='w-full h-full'>
      <div>
        <CustomTable
          data={itemsData?.data || []}
          columns={columnsData}
          isLoading={loading}
          emptyMessage={t('NoPriceListSubItemsDataFound')}
        />
        {itemsData?.data?.length > 0 && (
          <CustomPagination
            currentPage={itemsData?.page}
            rowsPerPage={itemsData?.per_page}
            totalRecords={itemsData?.total_records}
            totalPages={itemsData?.total_pages}
            onPageChange={onPageChange}
          />
        )}
      </div>
      <ConfirmationModal
        visible={openConfirmationModal}
        setVisible={setOpenConfirmationModal}
        header={t('ConfirmDelete')}
        acceptLabel={t('Delete')}
        rejectLabel={t('Cancel')}
        Icon={FaTrash}
        onAccept={handleDeleteItem}
        onReject={() => setSelectedItemData(null)}
        isLoading={buttonLoading}
      />
    </div>
  );
};

export default PriceItemsSubTypeTable;
